/**
 * Date and time in the workspace's own time zone, with the short zone name
 * ("Nov 1, 2026, 1:30 AM CDT"). Callers used to append a fixed "CT", which
 * hid the daylight-saving difference.
 */
import { getWorkspaceTimezone } from '@/lib/workspace'

const FALLBACK_TZ = 'America/Chicago'

function zoneOf(tz?: string | null): string {
  const candidate = (typeof tz === 'string' && tz.trim()) || getWorkspaceTimezone() || FALLBACK_TZ
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: candidate })
    return candidate
  } catch {
    return FALLBACK_TZ
  }
}

export function formatWorkspaceTime(iso: string | Date | null | undefined, tz?: string | null): string {
  if (iso == null) return ''
  const d = iso instanceof Date ? iso : new Date(iso)
  if (!Number.isFinite(d.getTime())) return ''
  // Some ICU builds use a narrow no-break space before AM/PM; normalize it.
  return new Intl.DateTimeFormat('en-US', {
    timeZone: zoneOf(tz),
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
  }).format(d).replace(/[\u202f\u00a0]/g, ' ')
}
